// @ts-nocheck
import { useState, useRef, useReducer, useEffect } from 'react';
import { Dialog } from "primereact/dialog";
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { Divider } from 'primereact/divider';
import { ScrollPanel } from 'primereact/scrollpanel';
import { ExplosionEntityOption } from './ParticleEffectInfo/ExplosionEntityOption';
import { SmokeEntityOption } from './ParticleEffectInfo/SmokeEntityOption';
import { RainEntityOption } from './ParticleEffectInfo/RainEntityOption';
import "../assets/functionalComponents/_dialog.scss"
import "../assets/functionalComponents/_dataItem.scss"
import "../assets/functionalComponents/ScrollPanelDemo.css"

const ParticleOption = (props) => {

    const [ExplosionEntity, setExplosionEntity] = useState(false);
    const [SmokeEntity, setSmokeEntity] = useState(false);
    const [RainEntity, setRainEntity] = useState(false);
    const [reChange, setReChange] = useState(false);
    const [particleList, setParticleList] = useState([]);
    const [lastList, setLastList] = useState([]);
    const [indexNum, setIndexNum] = useState("");
    const [entityRate, setEntityRate] = useState("");
    const [entitySize, setEntitySize] = useState("");
    const [entityLife, setEntityLife] = useState("");
    const [entityMinSpeed, setEntityMinSpeed] = useState("");
    const [entityMaxSpeed, setEntityMaxSpeed] = useState("");
    const [entityGravity, setEntityGravity] = useState("");
    const [entityRGBWeightR, setEntityRGBWeightR] = useState("");
    const [entityRGBWeightG, setEntityRGBWeightG] = useState("");
    const [entityRGBWeightB, setEntityRGBWeightB] = useState("");
    const [entityGeneratePeriod, setEntityGeneratePeriod] = useState("");
    const [entityRotatePerSecond, setEntityRotatePerSecond] = useState("");
    const [entityWindX, setEntityWindX] = useState("");
    const [entityWindY, setEntityWindY] = useState("");
    const [, forceUpdate] = useReducer(num => num + 1, 0);
    
    useEffect(() => {
        setParticleList(props.particleList);
    }, [props])

    const dialogFuncMap = {
        'ExplosionEntity': setExplosionEntity,
        'SmokeEntity': setSmokeEntity,
        'RainEntity': setRainEntity,
    }

    const onMenuItemClick = (index) => {
        let field = particleList[index];
        switch (field.effect) {
            case "爆炸":
                setExplosionEntity(true);
                setSmokeEntity(false);
                setRainEntity(false);
                break;
            case "煙霧":
                setSmokeEntity(true);
                setExplosionEntity(false);
                setRainEntity(false);
                break;
            case "雨水":
                setRainEntity(true);
                setSmokeEntity(false);
                setExplosionEntity(false);
                break;
            default:
                break;
        }
    }

    const onHide = (name) => {
        dialogFuncMap[`${name}`](false);
    }

    // 視窗轉移至粒子特效圖層位置
    const fieldgoto = (index) => {
        let field = particleList[index];
        let geo3dpoint = new Geo3DPoint(field.param.position);
        let geopoint = new GeoPoint(geo3dpoint.x, geo3dpoint.y + 0.0005, geo3dpoint.z + 10);
        let initialV = new Geo3DPoint(0, -1, 0);
        let initialUp = new Geo3DPoint(0, 0, 1);
        let initialCamera = new ov.Camera(geopoint, initialV, initialUp);
        window.main.OView.gotoCamera(initialCamera, true);
    }

    // 移除粒子特效圖層
    const fieldListRemove = (index) => {
        var particleModule;
        particleModule = window.main.OView.getModule("particle");
        let fields = particleList;
        let field = particleList[index];
        particleModule.removeParticleEntity(field.entity);
        props.toast.current.show({ severity: 'success', summary: '圖層資訊', detail: '已關閉' + field.effect + '粒子特效'});
        fields.splice(index, 1);
        setParticleList(fields);
        props.FieldOptionRemove(fields);
        forceUpdate();
    }

    // 用以變更爆炸特效參數
    const changeExplosion = (index) => {

        let fields = particleList;
        let field = particleList[index];
        let item = {};
        var particleModule;
        var explosionEntity;
        // 判斷變更是否捨棄及InputBox是否有輸入資料
        let param = {
            position:        field.param.position,
            size:            reChange ? lastList[0] : (entitySize            ? entitySize            : field.param.size),
            generatePeriod:  reChange ? lastList[1] : (entityGeneratePeriod  ? entityGeneratePeriod  : field.param.generatePeriod),
            rotatePerSecond: reChange ? lastList[2] : (entityRotatePerSecond ? entityRotatePerSecond : field.param.rotatePerSecond),
            rgbWeight:      [reChange ? lastList[3] : (entityRGBWeightR      ? entityRGBWeightR      : field.param.rgbWeight[0]), 
                             reChange ? lastList[4] : (entityRGBWeightG      ? entityRGBWeightG      : field.param.rgbWeight[1]),
                             reChange ? lastList[5] : (entityRGBWeightB      ? entityRGBWeightB      : field.param.rgbWeight[2])]
        };

        particleModule = window.main.OView.getModule("particle");
        explosionEntity = particleModule.addExplosionEntity(param);
        item.param = param;
        item.entity = explosionEntity;
        item.effect = "爆炸";
        item.count = field.count;
        particleModule.removeParticleEntity(field.entity);
        // 將變更後資訊存入原始資料位置
        fields.splice(index, 1, item);
        setParticleList(fields);
        props.FieldOptionRemove(fields);
        forceUpdate();
        setReset();
    }

    const changeSmog = (index) => {

        let fields = particleList;
        let field = particleList[index];
        let item = {};
        var particleModule;
        var smokeEntity;
        // 判斷變更是否捨棄及InputBox是否有輸入資料
        let param = {
            position:   field.param.position,
            rate:       reChange ? lastList[0] : (entityRate       ? entityRate       : field.param.rate),
            size:       reChange ? lastList[1] : (entitySize       ? entitySize       : field.param.size),
            life:       reChange ? lastList[2] : (entityLife       ? entityLife       : field.param.life),
            minSpeed:   reChange ? lastList[3] : (entityMinSpeed   ? entityMinSpeed   : field.param.minSpeed),
            maxSpeed:   reChange ? lastList[4] : (entityMaxSpeed   ? entityMaxSpeed   : field.param.maxSpeed),
            gravity:    reChange ? lastList[5] : (entityGravity    ? entityGravity    : field.param.gravity),
            rgbWeight: [reChange ? lastList[6] : (entityRGBWeightR ? entityRGBWeightR : field.param.rgbWeight[0]), 
                        reChange ? lastList[7] : (entityRGBWeightG ? entityRGBWeightG : field.param.rgbWeight[1]),
                        reChange ? lastList[8] : (entityRGBWeightB ? entityRGBWeightB : field.param.rgbWeight[2])]
        };

        particleModule = window.main.OView.getModule("particle");
        smokeEntity = particleModule.addSmokeEntity(param);
        item.param = param;
        item.entity = smokeEntity;
        item.effect = "煙霧";
        item.count = field.count;
        particleModule.removeParticleEntity(field.entity);
        // 將變更後資訊存入原始資料位置
        fields.splice(index, 1, item);
        setParticleList(fields);
        props.FieldOptionRemove(fields);
        forceUpdate();
        setReset();
    }

    const changeRain = (index) => {
        let fields = particleList;
        let field = particleList[index];
        let item = {};
        let level = null;
        var particleModule;
        var rainEntity;
        // 判斷變更是否捨棄及InputBox是否有輸入資料
        let size =  reChange ? lastList[0] : (entitySize  ? entitySize  : field.param.size);
        let windX = reChange ? lastList[1] : (entityWindX ? entityWindX : field.param.entityWindX);
        let windY = reChange ? lastList[2] : (entityWindY ? entityWindY : field.param.entityWindY);
        let windSpeed = new window.GeoPoint(windX, windY);

        switch(size) {
            case 1:
                level = ov.RAIN.LOW;
                break;
            case 2:
                level = ov.RAIN.MEDIUM;
                break;
            case 3:
                level = ov.RAIN.HIGH;
                break;
            default:
                break;
        }
        // 判斷變更是否捨棄及InputBox是否有輸入資料
        let param = {
            position:    field.param.position,
            size:        size,
            entityWindX: windX,
            entityWindY: windY,
            windSpeed:   windSpeed,
            level:       level,
            rgbWeight: [ reChange ? lastList[3] : (entityRGBWeightR ? entityRGBWeightR : field.param.rgbWeight[0]), 
                         reChange ? lastList[4] : (entityRGBWeightG ? entityRGBWeightG : field.param.rgbWeight[1]),
                         reChange ? lastList[5] : (entityRGBWeightB ? entityRGBWeightB : field.param.rgbWeight[2])]
        };
        particleModule = window.main.OView.getModule("particle");
        rainEntity = particleModule.addRainEntity(param);
        item.param = param;
        item.entity = rainEntity;
        item.effect = "雨水";
        item.count = field.count;
        particleModule.removeParticleEntity(field.entity);
        // 將變更後資訊存入原始資料位置
        fields.splice(index, 1, item);
        setParticleList(fields);
        props.FieldOptionRemove(fields);
        forceUpdate();
        setReset();
    }

    // 將參數還原
    const setReset = () => {
        setEntityRate("");
        setEntitySize("");
        setEntityLife("");
        setEntityMinSpeed("");
        setEntityMaxSpeed("");
        setEntityGravity("");
        setEntityWindX("");
        setEntityWindY("");
        setEntityGeneratePeriod("");
        setEntityRotatePerSecond("");
        setEntityRGBWeightR("");
        setEntityRGBWeightG("");
        setEntityRGBWeightB("");
        setReChange(false);
    }

    // 點擊設定按鈕時，將原先參數儲存，用以還原原始設定參數
    const storeLastParam = (index) => {
        let field = particleList[index];
        let list = [];
        if(field.param.rate)            list.push(field.param.rate);
        if(field.param.size)            list.push(field.param.size);
        if(field.param.life)            list.push(field.param.life);
        if(field.param.minSpeed)        list.push(field.param.minSpeed);
        if(field.param.maxSpeed)        list.push(field.param.maxSpeed);
        if(field.param.gravity)         list.push(field.param.gravity);
        if(field.param.generatePeriod)  list.push(field.param.generatePeriod);
        if(field.param.rotatePerSecond) list.push(field.param.rotatePerSecond);
        if(field.param.entityWindX)     list.push(field.param.entityWindX);
        if(field.param.entityWindY)     list.push(field.param.entityWindY);
        if(field.param.rgbWeight[0])    list.push(field.param.rgbWeight[0]);
        if(field.param.rgbWeight[1])    list.push(field.param.rgbWeight[1]);
        if(field.param.rgbWeight[2])    list.push(field.param.rgbWeight[2]);
        setLastList(list);
    }

    return (
        <div>
            <div>
            {
                particleList.map((item, index) => {
                    if (item.effect === "雨水") {
                        return (
                            <div>
                                <div className="field-item">
                                    <div className="field-detail">{index + 1}</div>
                                    <div className="field-detail">{item.effect} {item.count + 1}</div>
                                    <div className="field-action">
                                        <Button icon="pi pi-map-marker" className="p-button-rounded field-button" disabled/>
                                        <Button icon="pi pi-cog" className="p-button-rounded p-button-warning field-button" onClick={() => { storeLastParam(index); setReset(); onMenuItemClick(index); setIndexNum(index) }} />
                                        <Button icon="pi pi-times" className="p-button-rounded p-button-danger field-button"  onClick={() => { fieldListRemove(index) }} />
                                    </div>
                                </div>
                                <Divider />
                            </div>
                        )
                    } else {
                        return (
                            <div>
                                <div className="field-item">
                                    <div className="field-detail">{index + 1}</div>
                                    <div className="field-detail">{item.effect} {item.count + 1}</div>
                                    <div className="field-action">
                                        <Button icon="pi pi-map-marker" className="p-button-rounded field-button" onClick={() => { fieldgoto(index) }}/>
                                        <Button icon="pi pi-cog" className="p-button-rounded p-button-warning field-button" onClick={() => { storeLastParam(index); setReset(); onMenuItemClick(index); setIndexNum(index) }} />
                                        <Button icon="pi pi-times" className="p-button-rounded p-button-danger field-button"  onClick={() => { fieldListRemove(index) }} />
                                    </div>
                                </div>
                                <Divider />
                            </div>
                        )
                }})
            }
            </div>
            <div className="layout-main-container">
                <ExplosionEntityOption ExplosionEntity={ExplosionEntity} onHide={onHide} changeExplosion={changeExplosion} particleList={particleList} indexNum={indexNum} entitySize={entitySize} setEntitySize={setEntitySize} entityGeneratePeriod={entityGeneratePeriod} setEntityGeneratePeriod={setEntityGeneratePeriod} setReChange={setReChange}
                                       entityRotatePerSecond={entityRotatePerSecond} setEntityRotatePerSecond={setEntityRotatePerSecond} entityRGBWeightR = {entityRGBWeightR} setEntityRGBWeightR={setEntityRGBWeightR} entityRGBWeightG = {entityRGBWeightG} setEntityRGBWeightG={setEntityRGBWeightG} entityRGBWeightB = {entityRGBWeightB} setEntityRGBWeightB={setEntityRGBWeightB} />
                <SmokeEntityOption SmokeEntity={SmokeEntity} onHide={onHide} changeSmog={changeSmog} particleList={particleList} indexNum={indexNum} entityRate={entityRate} setEntityRate={setEntityRate} entitySize={entitySize} setEntitySize={setEntitySize} entityLife={entityLife} setEntityLife={setEntityLife} 
                                   entityMinSpeed = {entityMinSpeed} setEntityMinSpeed={setEntityMinSpeed} entityMaxSpeed = {entityMaxSpeed} setEntityMaxSpeed={setEntityMaxSpeed} entityGravity ={entityGravity} setEntityGravity ={setEntityGravity} 
                                   entityRGBWeightR = {entityRGBWeightR} setEntityRGBWeightR={setEntityRGBWeightR} entityRGBWeightG = {entityRGBWeightG} setEntityRGBWeightG={setEntityRGBWeightG} entityRGBWeightB = {entityRGBWeightB} setEntityRGBWeightB={setEntityRGBWeightB} setReChange={setReChange}/>
                <RainEntityOption RainEntity={RainEntity} onHide={onHide} changeRain={changeRain} particleList={particleList} indexNum={indexNum} entitySize={entitySize} setEntitySize={setEntitySize} entityWindX={entityWindX} setEntityWindX={setEntityWindX} entityWindY={entityWindY} setEntityWindY={setEntityWindY}
                                  entityRGBWeightR = {entityRGBWeightR} setEntityRGBWeightR={setEntityRGBWeightR} entityRGBWeightG = {entityRGBWeightG} setEntityRGBWeightG={setEntityRGBWeightG} entityRGBWeightB = {entityRGBWeightB} setEntityRGBWeightB={setEntityRGBWeightB} setReChange={setReChange}/>
            </div>
        </div>
    )
}

export const ParticleEffectComponents = (props) => {

    const [selectType, setSelectType] = useState(null);
    const [particleList, setParticleList] = useState([]);
    const [fieldGeo, setFieldGeo] = useState(null);
    const [, forceUpdate] = useReducer(num => num + 1, 0);
    const toast = useRef(null);
    
    useEffect(() => {
        if (fieldGeo === null)
            return;
        let param = null;
        let list = [];
        let item = {};
        var count = 0;
        var particleModule;
        var smokeEntity;
        var explosionEntity;
        var rainEntity;

        // 取得滑鼠點擊對應座標並取得地形高度，避免粒子特效出現在地形之下
        let point = new window.Geo3DPoint(fieldGeo.x, fieldGeo.y, fieldGeo.z);
        let surfaceHeight = window.main.OView.getAbsHeight(point, 4326);

        switch (selectType) {
            case 0 :
                item = {};
                param = {
                    position: new window.Geo3DPoint(fieldGeo.x, fieldGeo.y, surfaceHeight + 5),
                    size: 5,
                    generatePeriod: 1,
                    rotatePerSecond: 0,
                    rgbWeight: [1.0, 1.0, 1.0]
                };
                particleModule = window.main.OView.getModule("particle");
                explosionEntity = particleModule.addExplosionEntity(param);
                // 用於編號產生的爆炸特效
                particleList.forEach(item => {
                    if (item.effect === "爆炸") {
                        count = count + 1;
                    }
                })
                item.param = param;
                item.entity = explosionEntity;
                item.effect = "爆炸";
                item.count = count;
                // 建構後將必要參數資訊存入particleList
                list = particleList;
                list.push(item);
                setParticleList(list);
                break;
            case 1 :
                item = {};
                param = {
                    position: new window.Geo3DPoint(fieldGeo.x, fieldGeo.y, surfaceHeight + 5),
                    rate: 150,
                    size: 5,
                    life: 5,
                    minSpeed: 2,
                    maxSpeed: 6,
                    gravity: 1,
                    rgbWeight: [1.0, 1.0, 1.0]
                };
                particleModule = window.main.OView.getModule("particle");
                smokeEntity = particleModule.addSmokeEntity(param);
                // 用於編號產生的煙霧特效
                particleList.forEach(item => {
                    if (item.effect === "煙霧") {
                        count = count + 1;
                    }
                })
                item.param = param;
                item.entity = smokeEntity;
                item.effect = "煙霧";
                item.count = count;
                // 建構後將必要參數資訊存入particleList
                list = particleList;
                list.push(item);
                setParticleList(list);
                break;
            case 2 :
                item = {};
                param = {
                    position: new window.Geo3DPoint(fieldGeo.x, fieldGeo.y, surfaceHeight + 5),
                    size: 1,
                    entityWindX: 0,
                    entityWindY: 0,
                    windSpeed: new window.GeoPoint(0, 0),
                    level: ov.RAIN.LOW,
                    rgbWeight: [1.0, 1.0, 1.0]
                };
                particleModule = window.main.OView.getModule("particle");
                rainEntity = particleModule.addRainEntity(param);
                // 用於編號產生的雨水特效
                particleList.forEach(item => {
                    if (item.effect === "雨水") {
                        count = count + 1;
                    }
                })
                item.param = param;
                item.entity = rainEntity;
                item.effect = "雨水";
                item.count = count;
                // 建構後將必要參數資訊存入particleList
                list = particleList;
                list.push(item);
                setParticleList(list);
                break;
            default:
                break;
        }
    }, [fieldGeo])

    const addExplode = () => {
        window.main.OView.addEventListener("InputCompleted", fieldOutput);
        toast.current.show({ severity: 'info', summary: '標註資訊', detail: '請點擊滑鼠左鍵開始增建爆炸' });
        window.main.OView.inputSurfacePoint();
    }

    const addSmog = () => {
        window.main.OView.addEventListener("InputCompleted", fieldOutput);
        toast.current.show({ severity: 'info', summary: '標註資訊', detail: '請點擊滑鼠左鍵開始增建煙霧' });
        window.main.OView.inputSurfacePoint();
    }

    const addRain = () => {
        window.main.OView.addEventListener("InputCompleted", fieldOutput);
        toast.current.show({ severity: 'info', summary: '標註資訊', detail: '請點擊滑鼠左鍵開始增建雨水' });
        window.main.OView.inputSurfacePoint();
    }
    
    const fieldOutput = (event) => {
        if (event.success) {
            setFieldGeo(event.geo);
            forceUpdate();
            window.main.OView.removeEventListener("InputCompleted", fieldOutput);
        }
    }

    const FieldOptionRemove = (layers) => {
        setParticleList(layers);
        forceUpdate();
    }


    return (
        <div>
            <Toast ref={toast} />
            <Dialog header="粒子特效" visible={props.Particle} modal={false} keepInViewport={false} onHide={() => props.onHide('Particle')}>
                <Card>
                    <div className="field-item" style={{ width: '95%'}}>
                        <div className="field-object">項次</div>
                        <div className="field-object">項目</div>
                        <div className="field-object">功能</div>
                    </div>  
                    <Divider />
                    <div className="scrollpanel-demo">
                        <ScrollPanel style={{ width: '100%', height: '350px' }} className="custombar1">
                            <ParticleOption particleList={particleList} FieldOptionRemove={FieldOptionRemove} toast={toast} />
                        </ScrollPanel>
                    </div>
                </Card> 
                <br></br>
                <Card>
                    <div className="field grid">
                        <div className="col-12 md:col-4">
                            <Button label="新增爆炸" icon="pi pi-plus" className="p-button-raised" onClick={() => {addExplode(); setSelectType(0)}} style={{ width: "100%" }} /> 
                        </div>
                        <div className="col-12 md:col-4">
                            <Button label="新增煙霧" icon="pi pi-plus" className="p-button-raised" onClick={() => {addSmog(); setSelectType(1)}} style={{ width: "100%" }} />
                        </div>
                        <div className="col-12 md:col-4">
                            <Button label="新增雨水" icon="pi pi-plus" className="p-button-raised" onClick={() => {addRain(); setSelectType(2)}} style={{ width: "100%" }} /> 
                        </div>
                    </div>
                </Card>
            </Dialog>
        </div>
    )
}